<div class="root-container">
  <internal-sidebar
      #sidebar
      role="Field Application Specialist"
      [links]="navLinks"
      class="sidebar"
      tabindex="0"/>

  <div class="main">
      <common-header (showSidebar)="showSidebar()"/>
          <div class="content scrollbars">
            <div class="container">
              <router-outlet/>
            </div>
          </div>
        <common-footer/>
    </div>
  <modals #modals/>
  <toast #toast/>
  <image-preview
    #preview
  ></image-preview>
</div>
